import React from 'react'
import moment from 'moment'

// components
import {
  CRow,
  CFormLabel,
  CFormText
} from '@coreui/react-pro'
import AppTextColumnDetails from '../../../details/general-details/AppTextColumnDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'

// helpers
import { convertMoney } from '../../../../helpers/format-number'

const AppModalDetails = ({
  payrollDetails,
  handleViewFile
}) => {
  return (
    <>
      <CRow>
        <AppTextColumnDetails
          className='mb-3'
          colSize="4"
          title="Salary value (Nett Take Home Pay)"
          subtitle={payrollDetails?.value ? `IDR ${convertMoney(payrollDetails?.value)}` : '-'}
        />
        <AppTextColumnDetails
          colSize="4"
          className='mb-3'
          title="Payroll Tax"
          subtitle={payrollDetails?.tax_value ? `IDR ${convertMoney(payrollDetails?.tax_value)}` : '-'}
        />
        <AppTextColumnDetails
          colSize="4"
          className='mb-3'
          title="Payroll date"
          subtitle={payrollDetails?.date ? moment(payrollDetails?.date).format('DD/MM/YYYY') : '-'}
        />
        <AppTextColumnDetails
          className='mb-3'
          colSize="4"
          title="BPJS kesehatan"
          subtitle={payrollDetails?.bpjs_kesehatan ? `IDR ${convertMoney(payrollDetails?.bpjs_kesehatan)}` : '-'}
        />
        <AppTextColumnDetails
          className='mb-3'
          colSize="4"
          title="BPJS ketenagakerjaan"
          subtitle={payrollDetails?.bpjs_ketenagakerjaan ? `IDR ${convertMoney(payrollDetails?.bpjs_ketenagakerjaan)}` : '-'}
        />
      </CRow>
      <CRow className='mb-3'>
        <CFormLabel>
          Document Payroll
        </CFormLabel>
        {
          payrollDetails?.attachments?.length > 0 ? (
            <FormFileThumbnail 
              colSize="6"
              files={payrollDetails?.attachments}
              isDetailPage={true}
              handleViewFile={handleViewFile}
            />
          ) : (
            <CFormText>
              No attachment
            </CFormText>
          )
        }
      </CRow>
      <CRow className='mb-3'>
        <CFormLabel>
          Salary Slip
        </CFormLabel>
        {
          payrollDetails?.salary_slip ? (
            <FormFileThumbnail 
              colSize="6"
              files={[payrollDetails?.salary_slip]}
              isDetailPage={true}
              handleViewFile={handleViewFile}
            />
          ) : (
            <CFormText>
              No attachment
            </CFormText>
          )
        }
      </CRow>
    </>
  )
}

export default AppModalDetails
